import { v2Icon } from './theme'

/** Illustrated mark. The clay art carries its own colour, so it sits bare (no backplate), as in the app. */
export function V2Icon({ name, size = 32, className = '' }: { name: string; size?: number; className?: string }) {
  return (
    <img
      src={v2Icon(name)}
      alt=""
      width={size}
      height={size}
      decoding="async"
      draggable={false}
      className={`object-contain shrink-0 select-none ${className}`}
      style={{ width: size, height: size }}
    />
  )
}
